<template>
  <div>
    <rp-genkeys
      v-model="generationData"
      @submit="onSubmit"
    />
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Overlay from 'raypro_ui/src/components/ui/Overlay'
import Alert from 'raypro_ui/src/components/ui/Alert'
import page from '@/mixins/page'
import GenerateKeys from 'raypro_ui/src/components/ui/forms/GenerateRegistrationKeys'
import {generateProductKeys} from 'raypro_ui/src/api/product_keys'

export default {
  components: {
    'rp-overlay': Overlay,
    'rp-alert': Alert,
    'rp-genkeys': GenerateKeys
  },

  mixins: [page],

  data() {
    return {
      title: 'Manage Registration Keys',
      generationData: {
        numKeys: 1,
        duration: 12,
        result: ''
      }
    }
  },

  computed: {
    ...mapGetters(['authUser']),

    generationPayload() {
      return {data:{number:this.generationData.numKeys,duration:this.generationData.duration}}
    }
  },

  methods: {
    onSubmit() {
      generateProductKeys(this.generationPayload)
        .then((data) => {
          data["data"].forEach(x => {
            this.generationData.result += x + '\n'
          });
         })
        .catch((data) => {
        })
    }
  }
}
</script>

<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/Settings/ManageRegistrationKeys.vue